"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInAppAgentLlmCallObservationId = exports.getInAppAgentInstrumentationTraceId = exports.getInAppAgentInstrumentationObservationId = exports.IN_APP_AGENT_MCP_TOOL_OVERRIDE_HEADER = exports.IN_APP_AGENT_SILENT_MCP_OUTPUT_MESSAGE = exports.IN_APP_AGENT_SILENT_MCP_OUTPUT_TYPE = exports.IN_APP_AGENT_UNSETTLED_RUN_STATUSES = exports.IN_APP_AGENT_GENERIC_ERROR_MESSAGE = exports.IN_APP_AGENT_TOOL_REJECTION_ERROR_CODE = exports.IN_APP_AGENT_REDIRECT_TOOL_NAME = void 0;
exports.isUnsettledInAppAgentRunStatus = isUnsettledInAppAgentRunStatus;
exports.isSettledInAppAgentRunStatus = isSettledInAppAgentRunStatus;
const types_1 = require("../features/inAppAgent/types");
// Avoid renaming this as the FE is aware of this when rendering, renaming it would cause history issues
exports.IN_APP_AGENT_REDIRECT_TOOL_NAME = "langfuse_proposeRedirect";
exports.IN_APP_AGENT_TOOL_REJECTION_ERROR_CODE = "tool_call_rejected";
exports.IN_APP_AGENT_GENERIC_ERROR_MESSAGE = "An error occurred. Please try again or start a new conversation.";
/** Runs that are not yet in a terminal state, including parked approvals. */
exports.IN_APP_AGENT_UNSETTLED_RUN_STATUSES = [
    types_1.InAppAgentRunStatus.QUEUED,
    types_1.InAppAgentRunStatus.RUNNING,
    types_1.InAppAgentRunStatus.AWAITING_APPROVAL,
];
function isUnsettledInAppAgentRunStatus(status) {
    return exports.IN_APP_AGENT_UNSETTLED_RUN_STATUSES.includes(status);
}
function isSettledInAppAgentRunStatus(status) {
    return !isUnsettledInAppAgentRunStatus(status);
}
exports.IN_APP_AGENT_SILENT_MCP_OUTPUT_TYPE = "silent-mcp-output";
exports.IN_APP_AGENT_SILENT_MCP_OUTPUT_MESSAGE = "Output saved to /workspace/tool_calls";
// Header used only by Langfuse's server-side in-app agent when it calls the
// Langfuse MCP endpoint with a temporary in-app-agent API key and run override.
exports.IN_APP_AGENT_MCP_TOOL_OVERRIDE_HEADER = "x-langfuse-in-app-agent-tool-override";
// Observation ids stay equal to the per-turn run id so persisted messages,
// feedback, and traced generations all point at the same Langfuse observation.
const getInAppAgentInstrumentationObservationId = (runId) => runId;
exports.getInAppAgentInstrumentationObservationId = getInAppAgentInstrumentationObservationId;
// Each in-app agent turn gets its own trace derived from the run id so trace-
// level telemetry and feedback aggregate on the same per-turn trace.
const getInAppAgentInstrumentationTraceId = (runId) => `${runId}-trace`;
exports.getInAppAgentInstrumentationTraceId = getInAppAgentInstrumentationTraceId;
// Per-LLM-call generation ids stay deterministic from the run so retries and
// late flushes can address the same observation.
const getInAppAgentLlmCallObservationId = (runId, stepNumber) => `${runId}-llm-${stepNumber}`;
exports.getInAppAgentLlmCallObservationId = getInAppAgentLlmCallObservationId;
